import {
  AssignedTagToRSimDTO,
  FetchAssignedTagToRSimsFilter,
} from '../../../tags/models/tagsApi.types';
import { createAsignTagApi, createTagApiService } from 'tags/utils/createTagApiService';
import { envVariables } from 'src/common/utils/envVariables';

const API_PATH = envVariables.VITE_RSIM_PRODUCTS_API;
const { fetchTags, fetchTag, createTag } = createTagApiService({
  baseApiPath: API_PATH,
});

export const fetchRSimProductTags = fetchTags;

export const fetchRSimProductTag = fetchTag;

export const createRSimProductTag = createTag;

const { fetchAssignedTagsToCards, fetchAssignedTagsToCard, assignTagsToCard } = createAsignTagApi<
  FetchAssignedTagToRSimsFilter,
  AssignedTagToRSimDTO[]
>({
  baseApiPath: API_PATH,
  cardIdName: 'euicc',
  cardArrayIdsName: 'euiccs',
});

export const assignTagsToRSimProduct = assignTagsToCard;

export const fetchAssignedTagToRSimProduct = fetchAssignedTagsToCard;

export const fetchAssignedTagToRSimsProducts = fetchAssignedTagsToCards;
